module.exports = __webpack_public_path__ + "static/media/add-circle.f46ac7f1.svg";